import React from "react";
import { useRouter } from "next/router";

import FunnelTopHeader from "./FunnelTopHeader";
import FunnelSubHeader from "./FunnelSubHeader";
import { STEP_CART } from "components/funnel/constants";

export default function MobileFunnelHeader({ children, cta }) {
  const router = useRouter();
  return (
    <>
      {router.query?.step === STEP_CART ? <FunnelSubHeader cta={cta} /> : null}
      <FunnelTopHeader>{children}</FunnelTopHeader>
    </>
  );
}
